import { BaseCrud, IDataProviderFilter, IFilter, Logic } from 'core-components/types'

const isFilter = (filter: IDataProviderFilter | IFilter): filter is IFilter =>
  'field' in filter && 'value' in filter

export const extractFieldValueFromFilter = (source: BaseCrud, field: string) => {
  const currentFilter = source.getFilter()
  const fieldFilter = currentFilter?.filters.find((i) => isFilter(i) && i.field === field) as
    | IFilter
    | undefined

  return (fieldFilter?.value as number | undefined) ?? null
}

export const getFilterWithoutFieldFilter = (source: BaseCrud, field: string) => {
  const currentFilter = source.getFilter()

  const newFilter: IDataProviderFilter = {
    logic: Logic.AND,
    filters: currentFilter
      ? currentFilter.filters.filter((el) => 'field' in el && el.field !== field).slice()
      : [],
  }

  return newFilter
}
